import React, { createContext, useCallback, useContext, useState } from 'react';
import EnquiryModal from '../components/EnquiryModal';

const Ctx = createContext({ openEnquiry: () => {}, closeEnquiry: () => {} });

/**
 * Global provider for the in-app enquiry form. Replaces direct wa.me links on
 * Live Classes / Siddha Healing CTAs — the enquiry is emailed to the admin so
 * the personal number is never exposed in the page source.
 *
 * Usage: const { openEnquiry } = useEnquiry(); openEnquiry('live' | 'healing' | 'general')
 */
export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState('general');
  const openEnquiry = useCallback((k = 'general') => { setKind(k); setOpen(true); }, []);
  const closeEnquiry = useCallback(() => setOpen(false), []);
  return (
    <Ctx.Provider value={{ openEnquiry, closeEnquiry }}>
      {children}
      <EnquiryModal open={open} onClose={closeEnquiry} kind={kind} />
    </Ctx.Provider>
  );
};

export const useEnquiry = () => useContext(Ctx);
